export const pathWithId = (path: string, id: string) => {
	return path.replace('{id}', id);
};
